/* oxlint-disable typescript/consistent-type-assertions */
import { Badge, type BadgeType, formatDate, formatMoney, Timeline } from '@repo/design-system-kit';
import { IconCheckmarkRoundedFilled, IconDotOutlined } from '@repo/monochrome-icons';
import { useIntl } from 'react-intl';
import cx from 'clsx';
import {
  type EstimationBillingMilestone,
  EstimationSpecialOfferType,
} from '@repo/shared-kit/pricing/types';
import styles from './billing-milestones.module.css';
const BILLING_TAG_TO_BADGE_TYPE: Record<string, BadgeType | undefined> = {
  [EstimationSpecialOfferType.Promo]: 'promo',
  [EstimationSpecialOfferType.Trial]: 'tryForFree',
};
export function BillingMilestones({
  milestones = [],
}: {
  milestones?: EstimationBillingMilestone[];
}) {
  const { formatMessage, locale } = useIntl();
  const today = new Date().toISOString().slice(0, 10);
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h4 className="body-prominent">
          {formatMessage({ id: 'shared-kit.pricing.subscription-change.billing-milestones' })}
        </h4>
        <p className={cx('body-standard', styles.headerSubtitle)}>
          {formatMessage({ id: 'shared-kit.pricing.subscription-change.pricing.inc-taxes' })}
        </p>
      </div>
      <Timeline
        className={styles.milestonesTimeline}
        list={milestones.map(milestone => ({
          id: milestone.date,
          lineVariant: 'dashed',
          slots: {
            media:
              milestone.date === today ? (
                <IconCheckmarkRoundedFilled className={styles.progressStatusIcon} />
              ) : (
                <IconDotOutlined className={styles.progressStatusIcon} />
              ),
            title: (
              <div className={cx('body-standard', styles.milestoneTitle)}>
                <p className={styles.milestoneTitleContent}>
                  {milestone.date === today
                    ? formatMessage({ id: 'generic.dates.today' })
                    : formatDate({ date: milestone.date, locale, token: 'date-year-l' })}
                  {milestone.billingTags.map(tag => (
                    <Badge key={tag} type={BILLING_TAG_TO_BADGE_TYPE[tag] as BadgeType} />
                  ))}
                </p>
                <p className={cx(milestone.isNegative ? styles.negative : '')}>
                  {formatMoney({
                    amount: milestone.amount.value,
                    currency: milestone.amount.currency,
                    token: 'money-symbol',
                  })}
                </p>
              </div>
            ),
            content: milestone.subtitle ? (
              <div className={styles.milestoneContent}>{milestone.subtitle}</div>
            ) : undefined,
          },
        }))}
      />
    </div>
  );
}
